const PRODUCT_WISE_CHARGE_TYPES = [
    'brokerage_fee_product_wise',
    'barging_fee_product_wise',
    'trucking_fee_product_wise',
];

const isProductWiseChargeType = (chargeType) => PRODUCT_WISE_CHARGE_TYPES.includes(chargeType);

export const isValidPositiveAmountMax15Integer = (value) => {
    if (!value) return true;
    const amountString = String(value);
    const [integerPart] = amountString.split('.');
    if (integerPart.length > 15) {
        return false;
    }
    return parseFloat(value) > 0;
};

export const isValidPositiveAmountMax15IntegerMax3Decimals = (value) => {
    if (!value) return true;
    const amountString = String(value);
    const [integerPart, decimalPart] = amountString.split('.');
    if (integerPart.length > 15) {
        return false;
    }
    if (decimalPart && decimalPart.length > 3) {
        return false;
    }
    if (integerPart.length === 15 && !decimalPart) {
        return false;
    }
    return parseFloat(value) > 0;
};

export const isValidPositiveAmountMax15IntegerMax2Decimals = (value) => {
    if (!value) return true;
    const amountString = String(value);
    const [integerPart, decimalPart] = amountString.split('.');
    if (integerPart.length > 15 || (decimalPart && decimalPart.length > 2)) {
        return false;
    }
    if (integerPart.length === 15 && !decimalPart) {
        return false;
    }
    return parseFloat(value) > 0;
};

export const getAdditionalChargeItemError = (parentObject, parentArray, i) => {
    if (parentObject.chargeType !== '' && parentObject.chargeType !== undefined && !parentObject.amount) {
        return {
            path: `additional_charges[${i}].amount`,
            message: 'Amount is required',
        };
    }
    if (
        parentObject.chargeType === 'other' &&
        parentObject.chargeType !== undefined &&
        !parentObject.other_charge_name
    ) {
        return {
            path: `additional_charges[${i}].chargeType`,
            message: 'Please enter other charge name in below textbox',
        };
    }
    if (
        isProductWiseChargeType(parentObject.chargeType) &&
        parentObject.chargeType !== undefined &&
        !parentObject.other_charge_name &&
        parentArray.some(
            (charge, index) =>
                index !== i &&
                charge.chargeType === parentObject.chargeType &&
                charge.productType === parentObject.productType
        )
    ) {
        return {
            path: `additional_charges[${i}].chargeType`,
            message: 'Same charges for the same product are already added here',
        };
    }
    if (
        isProductWiseChargeType(parentObject.chargeType) &&
        parentObject.chargeType !== undefined &&
        !parentObject.productType
    ) {
        return {
            path: `additional_charges[${i}].productType`,
            message: 'Product type is required for product-wise charge type',
        };
    }
    return null;
};

export function additionalChargesOtherChargeTest() {
    const parentArray = this.parent;
    for (let i = 0; i < parentArray.length; i++) {
        const error = getAdditionalChargeItemError(parentArray[i], parentArray, i);
        if (error) {
            throw this.createError(error);
        }
    }
    return true;
}
